import { CustomSection } from "./custom-section";
import {SignedFormFile} from "../signed-form-file";
export class CustomForm{
  id:number = 0;
  formName:string = '';
  groupName:string = '';
  sections:CustomSection[] = [];
  signedFiles: SignedFormFile[] = [];
};
